import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/layout/index.vue'

import { menuList } from './routes'
import { getMenuList } from '@/utils/common'
import XEUties, { filter } from 'xe-utils'
import { useCommon } from '@/store/useCommon';

let actionRouteList = []  //一些操作跳转的路由，业务平台无法设置这些权限
if (XEUties.searchTree(menuList, item => item.name === 'ProductOperating').length > 0) {
  actionRouteList = [
    {
      name: 'LiveCategory',
      path: '/operating/product-operating/live-category',
      meta: {
        title: '直播分类',
        icon: '',
        hidden: true,
        activeMenu: '/operating/product-operating'
      },
      component: () => import(/* webpackChunkName: "LiveChannelCategory" */ '@/views/operating/productOperations/LiveChannelCategory/index.vue')
    },
    {
      name: 'LiveContent',
      path: '/operating/product-operating/live-category/live-content',
      meta: {
        title: '直播内容',
        icon: '',
        hidden: true,
        activeMenu: '/operating/product-operating'
      },
      component: () => import(/* webpackChunkName: "LiveContent" */ '@/views/operating/productOperations/LiveChannelCategory/liveContent.vue')
    },
    {
      name: 'AddChannelToContent',
      path: '/operating/product-operating/live-category/live-content/add-channel',
      meta: {
        title: '添加频道',
        icon: '',
        hidden: true,
        activeMenu: '/operating/product-operating'
      },
      component: () => import(/* webpackChunkName: "LiveContent" */ '@/views/operating/productOperations/LiveChannelCategory/addChanneToContent.vue')
    },
    // {
    //   name: 'RecommendOperation',
    //   path: '/operating/product-operating/recommend-operation',
    //   meta: {
    //     title: '推荐管理',
    //     icon: '',
    //     hidden: true,
    //     activeMenu: '/operating/product-operating'
    //   },
    //   component: () => import(/* webpackChunkName: "RecommendOperation" */ '@/views/operating/productOperations/RecommendOperation/index.vue')
    // },
    // {
    //   name: 'OnDemand',
    //   path: '/operating/product-operating/on-demand',
    //   meta: {
    //     title: '点播分类',
    //     icon: '',
    //     hidden: true,
    //     activeMenu: '/operating/product-operating'
    //   },
    //   component: () => import(/* webpackChunkName: "OnDemand" */ '@/views/operating/productOperations/OnDemand/index.vue')
    // }
  ]
}

const routesList = getMenuList(menuList, actionRouteList)

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/welcome',
    component: HomeView,
    children: [
      {
        name: 'welcome',
        path: '/welcome',
        component: () => import('@/views/welcome.vue'),
        meta: {
          title: '首页',
          keepAlive: true,
          icon: 'icon-shezhi',
          hidden: true
        }
      },
      ...routesList
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => HomeView,
    redirect: '/404/no_page',
    children: [
      {
        path: '/404/no_page',
        name: '404',
        component: () => import('@/views/404.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404'
  },
  {
    path: '/empty',
    component: () => import('@/views/empty.vue')
  }
]


const router = createRouter({
  // 👇 __MICRO_APP_BASE_ROUTE__ 为micro-app传入的基础路由
  history: createWebHistory((window as any).__MICRO_APP_BASE_ROUTE__ || process.env.BASE_URL),
  // history: createWebHashHistory((window as any).__MICRO_APP_BASE_ROUTE__ || process.env.BASE_URL),
  routes,
})

// router.beforeEach((to, from, next) => {
//   useCommon().clearAxiosArr()
//   next()
// })

export default router
